/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pc_Faq_1_QInputs */

const en_pc_faq_1_q = /** @type {(inputs: Pc_Faq_1_QInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Is PhotoCraft ArtCraft really free?`)
};

const zh_pc_faq_1_q = /** @type {(inputs: Pc_Faq_1_QInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`PhotoCraft ArtCraft 真的免费吗？`)
};

/**
* | output |
* | --- |
* | "Is PhotoCraft ArtCraft really free?" |
*
* @param {Pc_Faq_1_QInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const pc_faq_1_q = /** @type {((inputs?: Pc_Faq_1_QInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pc_Faq_1_QInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_pc_faq_1_q(inputs)
	return zh_pc_faq_1_q(inputs)
});
export { pc_faq_1_q as "pc.faq.1.q" }